/* =========================

  FV

============================ */
import styled from "styled-components";
import { useSelector } from "react-redux";
import sanitize from "sanitize-html";

import {break_point_sp} from "../../../Styled/mixin";
import Image from "../../../Components/Part/Image";
import ImageRetina from "../../../Components/Part/ImageRetina";

import Btn from "../part/Btn";

/* -------------------------

  component

---------------------------- */
function Main( props ) {
  const state = useSelector((state)=>state.datasRecommend);
  let recommend;
  state.map((s,i)=>(
    (props.flagName === s.flagName)?recommend = s:""
  ))

  return (
    <Styled className="p-result__section_main p-sec">
      <div className="p-result__section_main__inner p-section__inner l-inner--1100">

        <div className="p-result__section_main__heading">
          <div className="p-result__section_main__heading__inner">
            <h2>
              <ImageRetina
                type={"png"}
                src_pc_1x={"/assets/img/result/fv/main_title.png"}
                src_pc_2x={"/assets/img/result/fv/main_title@2x.png"}
                src_sp_1x={"/assets/img/result/fv/sp/main_title.png"}
                src_sp_2x={"/assets/img/result/fv/sp/main_title@2x.png"}
                alt={"あなたにおすすめの商品はこちらです"}
              />
            </h2>
          </div>
        </div>{/* p-result__section_main__heading */}

        <div className="p-result__block_main p-block">
          <div className="p-result__block_main__inner p-result__block__inner">

            <div className="p-result__block_main__heading">
              <div className="p-result__block_main__heading__inner">
                <h3 className="c-font_f--km" dangerouslySetInnerHTML={{__html:sanitize(recommend.catchCopy.main)}}></h3>
                {(recommend.catchCopy.main_note !== "")?<p className="note">{recommend.catchCopy.main_note}</p>:""}
              </div>
            </div>{/* p-result__block_main__heading */}

            <div className="p-result__block_main__content">
              <div className="p-result__block_main__staff pc_only">
                <ImageRetina
                  type={"png"}
                  src_pc_1x={"/assets/img/result/fv/main_staff.png"}
                  src_pc_2x={"/assets/img/result/fv/main_staff@2x.png"}
                  alt={""}
                />
              </div>
              <div className="p-result__block_main__content__inner">

              <div className="p-result__box_main">
                <div className="p-result__box_main__inner">

                  <div className={`p-result__box_main__left ${(recommend.flagName === "goku" || recommend.flagName === "ninniku_ginger" || recommend.flagName === "dento_ninniku_ranou" || recommend.flagName === "ninniku_kurozu")?"image_padding":""}`}>
                    <Image
                      src={`/assets/img/result/fv/products/${recommend.flagName}.png`}
                      alt={recommend.productName}
                    ></Image>
                  </div>

                  <div className="p-result__box_main__right l-box">

                    <div className="p-result__box_main__right__part_top l-box__txt">
                      <p className="p-result_txt_name l-box__txt c-font_f--km">
                        {(recommend.flagName == "ninniku_ranou")? <span className="p-result_txt_name--small">{recommend.productTag}</span> :""}
                        {recommend.productName}<span>{recommend.productSize}</span>
                      </p>
                      <p className="p-result_txt_price--teiki">
                        {recommend.productPrice_teiki}<span>円（税込）</span>
                      </p>
                      <p className="p-result_txt_price">
                        {recommend.productPrice}<span>円（税込）</span>
                      </p>
                    </div>

                    <div className="p-result__box_main__right__part_bottom l-box">
                      <Btn href={recommend.linkAbout}>詳しく見てみる</Btn>
                      <div className="l-box__part">
                      </div>
                    </div>
                  </div>

                </div>
              </div>{/* p-result__box_main */}

              </div>
            </div>

          </div>
        </div>{/* p-result__block_main p-block */}

      </div>
    </Styled>
  );
}

export default Main;

/* -------------------------

  styled

---------------------------- */

/*
ALL
---------------------------- */
const Styled = styled.section`
  .p-result__section_main__inner{
    padding: 35px 0;
  }
  .p-result__section_main__heading{
    margin: 0 auto 25px;
    width: 652px;
    .p-result__section_main__heading__inner{
      padding: 0 4%;
    }
    h2{
      text-align: center;
    }
  }
  .p-result__block_main{
    .p-result__block_main__heading{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 10px 100px;
      background: #325925;
      border-radius: 20px 20px 0 0;
      h3{
        font-size: 3.8rem;
        color: #ffffff;
        sup{
          font-size: 14px;
        }
      }
      .note{
        display:flex;
        justify-content: flex-end;
        color: #ffffff;
        font-size: 12px;
        line-height: 1.3em;
      }
    }
    .p-result__block_main__content{
      /* display: flex;
      width: 100%; */
      background: #ffffff;
      padding-left: calc((250/1100)*100%);
      border-radius: 0 0 20px 20px;
      position: relative;
      .p-result__block_main__staff{
        position: absolute;
        bottom:0;
        left: 5px;
        width: calc((230/1100)*100%);
      }
      .p-result__block_main__content__inner{
        /* width: calc((845/1100)*100%); */
        padding: 30px 20px 30px 0;
      }
    }
    .p-result__box_main{
      .p-result__box_main__inner{
        display: flex;
        width: 100%;
      }
      .p-result__box_main__left{
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc((370/845)*100%);
        position: relative;
        img{
          max-height: 280px;
        }
        &::before{
          content: " ";
          display: block;
          width: calc((120/370)*100%);
          padding-top: calc((110/370)*100%);
          background: url(${process.env.PUBLIC_URL}/assets/img/result/icn_rank_01.png) no-repeat;
          background-size: 100%;
          position: absolute;
          top: 0;
          left: calc((-100/370)*100%);
        }
      }
      .p-result__box_main__right{
        display: flex;
        flex-direction: column;
        width: 50%;
        .p-result__box_main__right__part_top{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-grow: 2;
          .p-result_txt_name{
            font-size: 2.8rem;
            text-align: center;
            font-weight: bold;
            span{
              display: block;
              font-size: 2.8rem;
            }
            .p-result_txt_name--small{
              font-size: 18px;
            }
          }
          .p-result_txt_price{
            display: flex;
            align-items: baseline;
            justify-content: center;
            width: 100%;
            font-size: 3.9rem;
            text-align: center;
            font-weight: bold;
            color: #360a08;
            span{
              font-size: 2.5rem;
            }
            &::before{
              content: "通常価格";
              display: block;
              align-self: center;
              width: calc(5em + 10px);
              margin: 0 10px 0 0;
              padding: 5px 5px 5px 5px;
              border: solid 2px #360a08;
              border-radius: 5px;
              line-height: 1em;
              color: #360a08;
              font-size: 1.8rem;
            }
          }
          .p-result_txt_price--teiki{
            display: flex;
            align-items: baseline;
            justify-content: center;
            width: 100%;
            font-size: 3.9rem;
            text-align: center;
            font-weight: bold;
            color: #c40000;
            position: relative;
            span{
              font-size: 2.5rem;
            }
            &::before{
              content: "毎月お届け";
              display: block;
              align-self: center;
              width: calc(5em + 10px);
              margin: 0 10px 0 0;
              padding: 5px 5px 5px 5px;
              border: solid 2px #c40000;
              border-radius: 5px;
              line-height: 1em;
              color: #c40000;
              font-size: 1.8rem;
            }
          }
        }
        .p-result__box_main__right__part_bottom{
          margin: 20px 0 0 0;
          flex-grow: 0;
          .l-box__part{
            text-align: right;
          }
        }
      }
    }
  }
	@media ${break_point_sp} {
    .p-result__section_main__inner{
      padding: 30px 4%;
    }
    .p-result__section_main__heading{
      margin-bottom: 0;
      width: 100%;
      h2{
        text-align: center;
      }
    }
    .p-result__block_main{
      .p-result__block_main__heading{
        padding: 15px 4%;
        h3{
          font-size: calc(6.1vw); /* SP: 6.4vw→6.1vw 見出し2行の収まり調整（KKK_ECSYTM-817） */
          white-space: pre-wrap;
        }
      }
      .p-result__block_main__content{
        display: block;
        width: 100%;
        padding: 30px 4%;
        position: static;
        .p-result__block_main__content__inner{
          width: 100%;
          padding: 0;
        }
      }
      .p-result__box_main{
        .p-result__box_main__inner{
          display: block;
        }
        .p-result__box_main__left{
          width: 100%;
          margin: 0 auto;
          &.image_padding{
            img{
              padding-left: calc((140/750)*100%);
            }
          }
          &::before{
            content: " ";
            display: block;
            width: calc((220/750)*100%);
            padding-top: calc((200/750)*100%);
            background: url(${process.env.PUBLIC_URL}/assets/img/result/icn_rank_01.png) no-repeat;
            background-size: 100%;
            position: absolute;
            top: 0;
            left: calc((-10/750)*100%);
          }
        }
        .p-result__box_main__right{
          width: 100%;
          .p-result__box_main__right__part_top{
            margin: 30px 0;
            .p-result_txt_name{
              font-size: calc((50/750)*100vw);
              span{
                display: block;
                font-size: calc((40/750)*100vw);
              }
              .p-result_txt_name--small{
                font-size: 18px;
              }
            }
            .p-result_txt_price{
              font-size: calc((70/750)*100vw);
              text-align: center;
              font-weight: bold;
              color: #360a08;
              span{
                font-size: calc((40/750)*100vw);
              }
              &::before{
                font-size: calc((25/750)*100vw);
                left: 2%;
              }
            }
            .p-result_txt_price--teiki{
              span{
                font-size: calc((40/750)*100vw);
              }
              &::before{
                font-size: calc((25/750)*100vw);
              }
            }
          }
        }
      }
    }
	}
`;
